import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation10 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };



    return (

<>
   



        <div className="container mt-1 p-3 mb-1" >


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}>
                       Certificate Course in Graphic Designing

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%"}}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in Video Editing
                </h5>
                <p>
                    Graphic Designer is the one who designs, creates, edits, manipulates various types of graphics.</p>

                <p>These graphics can be Photographs, pictures, drawings, icons, line arts, paintings etc. </p>

            </div>
            <hr />


            <h5 style={{ position: "relative" }}>
                What does Graphic Designer Do?
            </h5>
            <p>Using all these types of graphics, he/she can create flyers, posters, magazines, hoardings, book covers, brochures, product catalogs etc. He/She can also create web banners, buttons, icons, photomerge (collage), photo editing etc.</p>

            <p> Product packaging design, User Interface design, Corporate identity profiling are few more services a graphic designer can offer.</p>
            <hr />
            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>

            <p>A graphic designer can work with companies/enterprises working in print, web, multimedia, eLearning and gaming industry.</p>
            <p>Bachelor’s Degree/ Diploma in graphic design or a related field is usually required for jobs in this field. Candidates should demonstrate their creativity and originality through a professional portfolio that features their best designs. He/She can do a job or can work as a freelance designer. A fresher can draw up to Rs. 100,000/- p.a.</p>
            <hr />
            <h4>Hierarchy</h4>
            <p>In a typical print industry enterprise such as an advertising agency, he/she would work with a team of more graphic designers and an Art director who would guide them. In a web designing/multimedia firm, he/she would be a part of graphic designing / digital creations / content development team. He/She can further pursue to become a senior graphic designer or a web designer as per his/her liking and abilities.</p>
            <hr />
            <h4>Tools</h4>
            <p>Typically a graphic designer uses tools like Adobe Illustrator, Adobe InDesign, Adobe Photoshop for graphics creation and editing. Knowledge of few other tools like CorelDraw, Flash (graphics creation and basic animation) and few similar open source tools can be beneficial for a graphic designer</p>

            <hr />

            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> Graphic Designing course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>

            </div>
            <hr />
            
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
            </div>
            <hr />

            <h2>Syllabus</h2>

            <div className='p-4' >



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Adobe Illustrator</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li>Basics of Illustrator CS4</li>
                                <li>Introduction</li>
                                <li> The Working Place</li>
                                <li>Customizing</li>
                                <li>Tools</li>
                                <li>Layer And Layer Options</li>
                                <li>Pen, Pencils and Paths</li>
                                <li>Using the Brush and Paint</li>
                                <li>Specialized Tools</li>
                                <li>Getting Creative with Types</li>
                                <li> Using the Symbols</li>
                                <li>Designing Graphics</li>
                                <li>Effects and Filters</li>
                                <li>Playing With Palettes</li>
                                <li>Select, View and Object</li>
                                <li>Output</li>
                                <li>Exporting</li>
                                <li>Web and Devices</li>
                                <li>Settings</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Adobe Phototshop</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Basics of Photoshop CS4</li>
                                <li> Introduction</li>
                                <li>The Working Place</li>
                                <li>Customizing</li>
                                <li>Image and Color Modifications</li>
                                <li>Tools</li>
                                <li>Using the Brush and Paint</li>
                                <li>Working with Selections</li>
                                <li>Scaling</li>
                                <li>Knowing the Layers</li>
                                <li>Getting Creative With Types</li>
                                <li>Masks</li>
                                <li>Filter Gallery</li>
                                <li>Playing With Palettes</li>
                                <li>Color Adjustments</li>
                                <li>Automating</li>
                                <li>Web and Devices</li>
                                <li>Output</li>
                                <li>Settings</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Adobe InDesign</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li> Getting Started</li>
                                <li> Creating and Viewing a Document</li>
                                <li> Managing Pages and Books</li>
                                <li> Managing Text</li>
                                <li> Formatting Text</li>
                                <li> Placing and working with Graphics</li>
                                <li> Working with Objects</li>
                                <li> Managing and Transforming Objects</li>
                                <li> Working with Points and Paths</li>
                                <li> Applying and Managing Color</li>
                                <li> Working with Tables</li>
                                <li> Working with Styles</li>
                                <li> Finalizing Documents</li>
                                <li> Exporting a Document</li>
                                <li> Print and Output a Document</li>
                                <li> Setting Preferences</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>



            </div >
            <hr />
            <h5>Adobe Illustrator</h5>
            <p><b>Skills:</b> Working Place, Customizing, Tools, Layer And Layer Options, Pen, Pencils and Paths, Using the Brush and Paint, Specialized Tools, Getting Creative with Types, Using the Symbols, Designing Graphics, Effects and Filters, Playing With Palettes Select, View and Object, Automating, Exporting, Web and Devices</p>
            <p><b>Outputs:</b> Business Card, Labels, Letterhead, Coupon, Identity Card, Jewel Case Design, Book Mark, Sticker, Envelope, Magazine Advertisement
            </p>
            <hr />

            <h5>Adobe Photoshop</h5>
            <p><b>Skills:</b> Working Place, Customizing, Image and Color Modifications, Case Study - Black & White to Color, Using the Brush and Paint, Working with Selections, Scaling, Knowing the Layers, Filter Gallery, Color Adjustments</p>
            <p><b>Outputs:</b> Web Layout Design, Web Banner, Advertisement, UI Design
            </p>
            <hr />

            <h5>Adobe InDesign</h5>
            <p><b>Skills:</b>Creating and Viewing a Document, Managing Pages and Books, Managing Text , Formatting , Working with Objects, Working with Points and Paths, Case Study- Book Cover, Applying and Managing Colors, Working with Tables, Working with Styles, Printing and Outputting a Document, Setting Preferences</p>
            <p><b>Outputs:</b>Story books, Wall Calendar, Newsletter, Maps, Menu Card, Magazine Cover Page, Recipe Book, Book Cover
            </p>
            <hr />

            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation10;